import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import {
  formatDurationSeconds,
  formatRelativeTime,
} from "@/v2-backoffice-client/uptime/uptime.utils"
import type { UptimeViewDetailQuery } from "@/v2-backoffice-client/uptime/view/detail/__types__/uptime.view.detail.query"

export type UptimeViewIncidentsProps = ComponentProps<"div"> & {
  incidents: UptimeViewDetailQuery["getUptimeTargetIncidents"]
}

function UptimeViewIncidents(props: UptimeViewIncidentsProps) {
  const { incidents, className, ...divProps } = props

  if (!incidents.length) {
    return (
      <div
        className={cn(
          "uptime-view-chart-frame text-sm text-muted-foreground text-center py-6",
          className,
        )}
        {...divProps}
      >
        No incidents in the last 90 days.
      </div>
    )
  }

  return (
    <div className={cn("uptime-view-chart-frame p-0", className)} {...divProps}>
      {incidents.map((i, idx) => {
        const ongoing = i.EndedAt == null
        return (
          <div
            key={`${i.StartedAt}-${idx}`}
            className="uptime-view-incident-row"
          >
            <div className="flex flex-col gap-0.5">
              <div className="text-sm font-medium">
                {formatRelativeTime(i.StartedAt)}
              </div>
              <div className="text-xs text-muted-foreground">
                {ongoing ? "ongoing" : `ended ${formatRelativeTime(i.EndedAt)}`}
              </div>
            </div>

            <div
              className="uptime-view-incident-error"
              title={i.LastError ?? ""}
            >
              {i.LastError ?? "no error message captured"}
            </div>

            <div className="text-sm font-medium tabular-nums">
              {formatDurationSeconds(i.DurationSeconds)}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default UptimeViewIncidents
